 import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
 import { Button } from "@/components/ui/button";
 import { Crown, ExternalLink } from "lucide-react";
 import { isIOSNative } from "@/utils/platform";
 
 interface PremiumStatusModalProps {
   isOpen: boolean;
   onClose: () => void;
   subscriptionPlan: 'monthly' | 'yearly' | null;
   onManageSubscription: () => void;
   isIOSPurchase?: boolean;
 }
 
 export function PremiumStatusModal({
   isOpen,
   onClose,
   subscriptionPlan,
   onManageSubscription,
   isIOSPurchase = false,
 }: PremiumStatusModalProps) {
   const isIOS = isIOSNative();
   
   const handleManageSubscription = () => {
     // On iOS native, use itms-apps scheme; on web use HTTPS link or Stripe portal
     if (isIOS || isIOSPurchase) {
       const appStoreUrl = isIOS 
         ? "itms-apps://apps.apple.com/account/subscriptions"
         : "https://apps.apple.com/account/subscriptions";
       window.open(appStoreUrl, "_blank");
     } else {
       // Web users go through Stripe portal
       onManageSubscription();
     }
     onClose();
   };
 
   const planLabel = subscriptionPlan === 'yearly' 
     ? 'Yearly Subscription' 
     : subscriptionPlan === 'monthly' 
       ? 'Monthly Subscription' 
       : 'Premium Subscription';
 
   return (
     <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
       <DialogContent className="max-w-sm mx-auto">
         <DialogHeader className="text-center space-y-4">
           <div className="mx-auto w-16 h-16 rounded-full evolve-gradient flex items-center justify-center">
             <Crown className="w-8 h-8 text-primary-foreground" />
           </div>
           <DialogTitle className="text-xl font-display">
             You are a Premium User
           </DialogTitle>
           <DialogDescription className="text-base text-foreground">
             {planLabel}
           </DialogDescription>
         </DialogHeader>
         
         <div className="flex flex-col gap-3 mt-6">
           <Button 
             variant="evolve" 
             className="w-full"
             onClick={handleManageSubscription}
           >
             <ExternalLink className="w-4 h-4 mr-2" />
             Manage Subscription
           </Button>
           <Button 
             variant="outline" 
             className="w-full"
             onClick={onClose}
           >
             Close
           </Button>
         </div>
       </DialogContent>
     </Dialog>
   );
 }